module.exports = __webpack_public_path__ + "static/img/gh_logo@3x.7287812.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/3x/gh_logo@3x.png
// module id = kqII
// module chunks = 1